import { createPaginator } from "@smithy/core";
import { ChimeSDKMessagingClient } from "../ChimeSDKMessagingClient";
import { ListChannelMessagesCommand, } from "../commands/ListChannelMessagesCommand";
export const paginateListChannelMessages = createPaginator(ChimeSDKMessagingClient, ListChannelMessagesCommand, "NextToken", "NextToken", "MaxResults");
